import type { IMultiCheckboxSubFormConfig } from "./MultiCheckboxSubForm.types";
import { dateFormat, i18nCrossUtil } from "@adgm/libs";

const crossIntl = i18nCrossUtil.t();

/**
 * InstitutionSourceOfFundForm 配置对象
 * 用于驱动通用 MultiCheckboxSubForm 组件
 * 所有文案从设计稿中提取
 */
export const INSTITUTION_SOURCE_OF_FUND_CONFIG: IMultiCheckboxSubFormConfig = {
  options: [
    {
      label: () => crossIntl["kyc.v2.option.label.income.normal.operations"],
      fieldKey: "normalOperationsOfCompany",
      subFormFields: [], // 空数组，不显示任何字段
      createInitialValue: () => ({
        empty: "empty", // 初始化时设置隐藏字段的值
      }),
    },
    {
      label: () => crossIntl["kyc.v2.option.label.funding.from.shareholder"],
      fieldKey: "fundingFromShareholder",
      subFormFields: [
        {
          name: "nameOfShareholder",
          label: () => crossIntl["kyc.v2.form.label.name.of.shareholder.s"],
          type: "input",
          required: true,
        },
        {
          name: "originatingFundsCountry",
          label: () => crossIntl["kyc.v2.form.label.country.of.originating.funds"],
          type: "input",
          required: true,
        },
      ],
      createInitialValue: () => ({
        nameOfShareholder: "",
        originatingFundsCountry: "",
      }),
    },
    {
      label: () => crossIntl["kyc.v2.option.label.dividends.returns.investment"],
      fieldKey: "returnsFromInvestment",
      subFormFields: [
        {
          name: "description",
          label: () => crossIntl["kyc.v2.form.label.description.of.investment.assets"],
          type: "input",
          required: true,
        },
        {
          name: "name",
          label: () => crossIntl["kyc.v2.form.label.name.of.investments"],
          type: "input",
          required: true,
        },
        {
          name: "purchasedDate",
          label: () => crossIntl["kyc.v2.form.label.purchased.date"],
          type: "datePicker",
          required: true,
          dateFormat,
        },
        {
          name: "amountReceivedPerAnnum",
          label: () => crossIntl["kyc.v2.form.label.amount.received.per.annum"],
          type: "input",
          required: true,
        },
      ],
      createInitialValue: () => ({
        description: "",
        name: "",
        purchasedDate: "",
        amountReceivedPerAnnum: "",
      }),
    },
    {
      label: () => crossIntl["kyc.v2.option.label.sale.of.assets.fund"],
      fieldKey: "saleOfAssets",
      subFormFields: [
        {
          name: "description",
          label: () => crossIntl["kyc.v2.form.label.description.of.asset"],
          type: "input",
          required: true,
        },
        {
          name: "saleDate",
          label: () => crossIntl["kyc.v2.form.label.sale.date"],
          type: "datePicker",
          required: true,
          dateFormat,
        },
        {
          name: "saleAmount",
          label: () => crossIntl["kyc.v2.form.label.sale.amount"],
          type: "input",
          required: true,
        },
      ],
      createInitialValue: () => ({
        description: "",
        saleDate: "",
        saleAmount: "",
      }),
    },
    {
      label: () => crossIntl["kyc.v2.option.label.debt.raising"],
      fieldKey: "debtRaising",
      subFormFields: [
        {
          name: "fundingEntities",
          label: () => crossIntl["kyc.v2.form.label.funding.entity.its"],
          type: "input",
          required: true,
        },
        {
          name: "countryOfFundingEntities",
          label: () => crossIntl["kyc.v2.form.label.country.of.funding.entity.ies"],
          type: "input",
          required: true,
        },
      ],
      createInitialValue: () => ({
        fundingEntities: "",
        countryOfFundingEntities: "",
      }),
    },
    {
      label: () => crossIntl["kyc.other.input"],
      fieldKey: "otherFundSource",
      isOther: true,
      otherPlaceholder: () => crossIntl["kyc.other.input"],
      otherTitleFieldName: "title",
      subFormFields: [
        {
          name: "description",
          label: () => crossIntl["kyc.v2.form.label.description.of.source.of.funds"],
          type: "input",
          required: true,
        },
        {
          name: "amountPerAnnum",
          label: () => crossIntl["kyc.v2.form.label.approximate.amounts.per.annum"],
          type: "input",
          required: true,
        },
        {
          name: "originatingCountry",
          label: () => crossIntl["kyc.v2.form.label.country.of.origin"],
          type: "input",
          required: true,
        },
      ],
      createInitialValue: () => ({
        title: "",
        description: "",
        amountPerAnnum: "",
        originatingCountry: "",
      }),
    },
  ],
};
